import jwtDecode from 'jwt-decode'
import React from 'react'
import { Container, Row, Col, Form } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { Link } from 'react-router-dom'

export default function Dashboard() { 
    const { t } = useTranslation()

    let token = jwtDecode(sessionStorage.getItem('jwt'))

    return (
        <>
            <Container className='cuerpo'>
                <Row className="text-left custom-card-header">
                <h1>{t('signin.manage')}</h1>
                <Form.Label className="form-label">{t('signin.selectaction')}</Form.Label>
                <br/><br/><br/>
                    <Row className="text-center my-3">
                        <Col>
                            <Link to="/manager/cards">
                                <i className="far fa-id-card custom-fas-big"></i>
                                <br/>
                                {t('menu.confirmcards')}
                            </Link>
                        </Col>
                        <Col>
                            <Link to="/manager/cardschange">
                                <i className="far fa-id-card custom-fas-big"></i>
                                <br/>
                                {t('menu.changecards')}
                            </Link>
                        </Col>
                    </Row>
                    <Row className="text-center my-3">
                        <Col>
                            <Link to="/manager/input">
                                <i className="far fa-id-card custom-fas-big"></i>
                                <br/>
                                {t('menu.input')}
                            </Link>
                        </Col>
                        { token?.counter
                            ?
                                <Col>
                                    <Link to="/manager/counters">
                                        <i className="far fa-id-card custom-fas-big"></i>
                                        <br/>
                                        {t('menu.counter')}
                                    </Link>
                                </Col>
                            :
                                <Col></Col>
                        }
                    </Row>
                </Row>
            </Container>
        </>
    )
}